import AttorneyResourceCenterShow from './AttorneyResourceCenterShow';

export default AttorneyResourceCenterShow;
